define('views/terms/term_links',[
    'backbone',
    'views/_base/baseview',
    'text!views/terms/term_links.html',
    'views/terms/terms_reroute'
], function(Backbone, BaseView, Template, TermsReRouteComponent){
    'use strict';

    return BaseView.extend({
        className: 'profile-content',
        tagName  : 'div',
        isRender : false,
        needsAuth: false,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};

            this.options = options.options || {};

            this.site_version = pf.getContent('version.id');

            this.terms_reroute = null;

            this.new_window = options.new_window;

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            this.addLinks();

            return this;
        },

        loadData: function(){

            this.openTermsView();

        },

        addLinks: function(){
            var that = this,
                links = pf.getContent('terms.content.links');

            if(_.isArray(links)){

                links.forEach(function(link){

                    var list_item = document.createElement('li'),
                        list_item_anchor = document.createElement('a');

                    list_item_anchor.className = link.class;
                    list_item_anchor.href = link.url;
                    list_item_anchor.innerHTML = link.text;

                    if(link.target){
                        list_item_anchor.target = link.target;
                    }
                    
                    list_item.appendChild(list_item_anchor);

                    that.$('.js-terms-list').append(list_item);

                });

            }

        },

        openTermsView: function(){

            switch(this.options.view){
                case 'terms':
                    this.showTerms();
                    break;
                default:
                    this.terms_reroute = new TermsReRouteComponent({ options: this.options, new_window: this.new_window });
                    break;
            }

        },

        showTerms: function(){
            this.render();
        },

        close: function(){}
    });
});

